module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/writing_gif-d344221f81df8dace9c5a6b99f9afda5.gif";